export const initialState = (page = {}) => ({
  id: page.id,
  recognition_text: null,
})

export const answerUpdate = (state = initialState(), payload) => ({
  ...state,
  recognition_text: payload[`mission_page_${state.id}`],
})

export default { initialState, answerUpdate }



// WEBPACK FOOTER //
// ./src/reducers/Missions/Answers/recognition.jsx